const firebaseConfig = {
  apiKey: "AIzaSyCZ_Rn_tbf4rFZ49mT0pc_4fJXXR55Se0Y",
  authDomain: "hotelzify-e6196.firebaseapp.com",
  databaseURL: "https://hotelzify-e6196-default-rtdb.firebaseio.com",
  projectId: "hotelzify-e6196",
  storageBucket: "hotelzify-e6196.appspot.com",
  messagingSenderId: "1015179130342",
  appId: "1:1015179130342:web:f98a77eced450ea4061227",
  measurementId: "G-LNK90H4DCN",
};

export { firebaseConfig };
